export const securityPrefsHasBubble = (application) => {
    return application.items.invalidNonVaultedItems.length > 0;
};
